export const parseJson = (str?: string | null) => {
  try {
    if (!str) {
      return null
    }
    return JSON.parse(str)
  } catch (error) {
    return null
  }
}